<script lang="ts">
    import translate from '../../../../lib/translate'
    import { showStore as show, buttonStore } from '../../stores'
    import { ButtonState } from '../../types/Bids'
    import BidButton from './BidButton.svelte'
    import label from './Inactive.translation'
</script>

<div class="auction-agent-display-show no-show">
    <div class="auction-agent-display-server-showbreak">
        <img draggable="false" src="{globalThis.config.baseUrl}/skin/frontend/default/juwelo2/images/logo_juwelo_quadrat.png" alt="Juwelo" />
        <p>{translate(label.state($show.state))}</p>
        {#if [ButtonState.loginAndBid, ButtonState.completeBidData].includes($buttonStore)}
            <BidButton on:bidButtonClick />
        {/if}
    </div>
</div>
